import Vue from "vue";
// @ts-ignore
import Chartkick from "vue-chartkick";
// @ts-ignore
import VueWordCloud from "vuewordcloud";
// @ts-ignore
import Chart from "chart.js";
import vuetify from '@/plugins/vuetify' // path to vuetify export
import Vuex from "vuex";
import VueI18n from "vue-i18n";
import messages from "@/language";
// @ts-ignore
import Vuelidate from "vuelidate";
// @ts-ignore
import VueHtml2Canvas from "vue-html2canvas";
// @ts-ignore
import JsonCSV from "vue-json-csv";

import App from "@/App.vue";
import store from "@/store";
import router from "@/router";

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(Vuelidate);
Vue.use(VueI18n);
Vue.use(VueHtml2Canvas);
Vue.use(require("jwt-simple"));

const i18n = new VueI18n({
  locale: "en",
  messages,
  fallbackLocale: "en"
});

Vue.use(Chartkick.use(Chart));
Vue.component(VueWordCloud.name, VueWordCloud);
Vue.component("downloadCsv", JsonCSV);

Vue.use(require("vue-moment"));

new Vue({
  i18n,
  store,
  router,
  // @ts-ignore
  vuetify: vuetify,
  render: h => h(App)
}).$mount("#app");
